<template>
  <base-pop-dialog :title="title" @onClose="handleClose" width="1300px">
    <template slot="content">
      <el-form
        ref="vehicleModelform"
        v-loading="loading"
        :model="vehicleModelInfo"
        :rules="rules"
        class="vehicle-model-content"
        label-width="130px"
        label-position="left"
      >
        <div class="vmc-box">
          <div class="vmc-row">{{ $t("vehicleModel.modelInformation") }}</div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicleModel.modelName')"
                prop="ModelName"
              >
                <el-input
                  v-model="vehicleModelInfo.ModelName"
                  size="small"
                  class="vmc-row-item-input"
                ></el-input>
              </el-form-item>
            </div>
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicle.fuelTankCapacity')"
                prop="FuelTankCapacityShow"
                label-width="145px"
              >
                <el-input
                  v-model="vehicleModelInfo.FuelTankCapacityShow"
                  size="small"
                  class="vmc-row-item-input"
                >
                  <template slot="append">{{ unitLiter }}</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="vmc-row-item">
              <el-form-item prop="FuelType" :label="$t('vehicle.fuelType')">
                <el-input
                  v-model="vehicleModelInfo.FuelType"
                  size="small"
                  class="vmc-row-item-input"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicle.vehicleWeight')"
                prop="VehicleWeight"
              >
                <el-select
                  size="small"
                  class="vmc-row-item-input"
                  v-model="vehicleModelInfo.VehicleWeight"
                  :placeholder="$t('tips.vehicles.select')"
                >
                  <el-option
                    v-for="item in vehicleWeightOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="vmc-row-item">
              <el-form-item
                prop="DisplacementShow"
                :label="$t('vehicle.displacement')"
                label-width="145px"
              >
                <el-input
                  v-model="vehicleModelInfo.DisplacementShow"
                  size="small"
                  class="vmc-row-item-input"
                >
                  <template slot="append">{{ unitLiter }}</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="vmc-row-item">
              <el-form-item :label="$t('vehicle.driverSeat')" prop="DriverSeat">
                <el-select
                  size="small"
                  class="vmc-row-item-input"
                  v-model="vehicleModelInfo.DriverSeat"
                >
                  <el-option :value="0" :label="$t('vehicle.left')"></el-option>
                  <el-option
                    :value="1"
                    :label="$t('vehicle.right')"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicle.vehicleWidth')"
                prop="VehicleWidthShow"
              >
                <el-input
                  v-model="vehicleModelInfo.VehicleWidthShow"
                  size="small"
                  class="vmc-row-item-input"
                >
                  <template slot="append">{{ unitCm }}</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicle.hoodLength')"
                prop="HoodLengthShow"
                label-width="145px"
              >
                <el-input
                  v-model="vehicleModelInfo.HoodLengthShow"
                  size="small"
                  class="vmc-row-item-input"
                >
                  <template slot="append">{{ unitCm }}</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="vmc-row-item"></div>
          </div>
        </div>
        <div class="vmc-box">
          <div class="vmc-row">{{ $t("vehicleModel.canBus") }}</div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item
                :label="$t('vehicleModel.connectionType')"
                prop="DBC.ConnectionType"
              >
                <el-select
                  size="small"
                  class="vmc-row-item-input"
                  :placeholder="$t('tips.vehicles.select')"
                  @change="handleConnectionTypeChange"
                  v-model="vehicleModelInfo.DBC.ConnectionType"
                >
                  <el-option value="J1939" label="J1939"></el-option>
                  <el-option value="OBD II" label="OBD II"></el-option>
                  <el-option value="None" label="None"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <template v-if="vehicleModelInfo.DBC.ConnectionType != 'None'">
            <div class="vmc-row">
              <div class="vmc-row-item" style="flex-basis: 60%">
                <el-form-item
                  :label="$t('vehicleModel.dbcFile')"
                  prop="DBC.IsCustomFile"
                  required
                >
                  <el-select
                    size="small"
                    class="vmc-row-item-input"
                    v-model="vehicleModelInfo.DBC.IsCustomFile"
                    @change="handleDBCMethodChange"
                  >
                    <el-option
                      :value="true"
                      :label="$t('vehicleModel.uploadCustomFile')"
                    ></el-option>
                    <el-option
                      :value="false"
                      :label="$t('vehicleModel.useStandardFile')"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <span
                  @click="downloadFile(instructionGuide)"
                  v-show="vehicleModelInfo.DBC.IsCustomFile"
                  v-html="
                    $t('vehicleModel.downloadInstructionGuide', instructionGuide)
                  "
                ></span>
              </div>
            </div>
            <div class="vmc-row" v-show="vehicleModelInfo.DBC.IsCustomFile">
              <div class="vmc-row-item" style="flex-basis: 60%">
                <el-form-item :label="$t('vehicle.deviceModel')">
                  <el-select
                    size="small"
                    class="vmc-row-item-input"
                    v-model="vehicleModelInfo.DBC.MainModel"
                    @change="handleDeviceModelChange"
                  >
                    <el-option
                      v-for="(item, key) in DeviceModelList"
                      :value="item.value"
                      :label="item.fullName"
                      :key="key"
                      ></el-option
                    >
                  </el-select>
                </el-form-item>
                <span
                  v-if="vehicleModelInfo.DBC.MainModel && vehicleModelInfo.DBC.MainModel !='D705'"
                  v-html="
                    $t('vehicleModel.downloadSampleDbcFile', {
                      url: sampleFile.url,
                      name: sampleFile.name,
                    })
                  "
                ></span>
              </div>
            </div>
            <div
              class="vmc-row"
              v-show="vehicleModelInfo.DBC.IsCustomFile && vehicleModelInfo.DBC.MainModel"
              style="border-top: none"
            >
              <div class="vmc-row-item">
                <el-form-item
                  :label="$t('vehicleModel.uploadDbcFile')" 
                >
                  <upload-d-b-c-file
                    :key="vehicleModelInfo.DBC.MainModel"
                    :main-model="vehicleModelInfo.DBC.MainModel"
                    :connection-type ="vehicleModelInfo.DBC.ConnectionType"
                    @uploadDone="handleUploadDone"
                  ></upload-d-b-c-file>
                </el-form-item>
              </div>
            </div>
            <div
              class="vmc-row"
              v-if="
                vehicleModelInfo.DBC.IsCustomFile && dbcFileList.length > 0
              "
            >
              <div class="vmc-row-item" style="flex-basis: 100%">
                <el-form-item :label="$t('vehicleModel.uploadedFiles')">
                    <DownloadDBCFile  
                      v-for="(value,index) in dbcFileList" 
                      :key="index" 
                      :file="value.Path"  
                      :file-name="value.FileName"
                    ></DownloadDBCFile>
                </el-form-item>
              </div>
            </div>

            <div v-if="!vehicleModelInfo.DBC.IsCustomFile" class="vmc-row">
              <div class="vmc-row-item" style="flex-basis: 60%">
                <el-form-item :label="$t('vehicleModel.standardDbcFile')">
                  <div class="file-name-box">
                    <i class="el-icon-document">standard.dbc</i>
                  </div>
                </el-form-item>
              </div>
            </div>
          </template>
        </div>
        <div class="vmc-box">
          <div class="vmc-row">{{ $t("vehicleModel.gSensorSensitivity") }}</div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item :label="$t('tripHistory.hardBraking')">
                <el-slider
                  class="vmc-row-item-slide"
                  v-model="vehicleModelInfo.DBASensitivity.HardBraking"
                  :min="1"
                  :max="11"
                  :step="1"
                  :marks="slideMarks"
                  :show-tooltip="false"
                >
                </el-slider>
              </el-form-item>
            </div>
          </div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item :label="$t('tripHistory.hardCornering')">
                <el-slider
                  class="vmc-row-item-slide"
                  v-model="vehicleModelInfo.DBASensitivity.HardCornering"
                  :min="1"
                  :max="11"
                  :step="1"
                  :marks="slideMarks"
                  :show-tooltip="false"
                >
                </el-slider>
              </el-form-item>
            </div>
          </div>
          <div class="vmc-row">
            <div class="vmc-row-item">
              <el-form-item :label="$t('tripHistory.hardRevving')">
                <el-slider
                  class="vmc-row-item-slide"
                  v-model="vehicleModelInfo.DBASensitivity.HardRevving"
                  :min="1"
                  :max="11"
                  :step="1"
                  :marks="slideMarks"
                  :show-tooltip="false"
                >
                </el-slider>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="button-row">
          <el-button
            size="small"
            class="ok-button"
            style="width: 150px"
            @click="onSave"
            :loading="isSaving"
          >
            {{ $t("globalText.save") }}
          </el-button>
          <el-button size="small" class="cancel-button" @click="handleClose"
            >{{ $t("globalText.cancel") }}
          </el-button>
        </div>
      </el-form>
    </template>
  </base-pop-dialog>
</template>

<script>
import BasePopDialog from "../../common/BasePopDialog";
import regExp from "../../../assets/js/RegExp";
import UploadDBCFile from "./UploadDBCFile";
import DownloadDBCFile from "./DownloadDBCFile";
import { numRound } from "../../../assets/js/Util";
import download from "downloadjs";
export default {
  name: "AddEditModelDialog",
  components: {
    UploadDBCFile,
    BasePopDialog,
    DownloadDBCFile,
  },
  props: {
    modeId: { type: String, default: null },
    isEdit: { type: Boolean, default: false },
  },
  data() {
    return {
      isSaving: false,
      loading: false,
      title: "",
      vehicleModelInfo: {
        DBC: {
          IsCustomFile: false,
          MainModel: "",
        },
        DBASensitivity: {},
      },

      DeviceModelList: [],
      vehicleInfoMetric: {
        FuelTankCapacityMetric: null,
        DisplacementMetric: null,
        VehicleWidthMetric: null,
        HoodLengthMetric: null,
      },
      slideMarks: {
        1: this.$t("settings.low"),
        6: this.$t("settings.medium"),
        11: this.$t("settings.high"),
      },
      FuelTankCapacityRange: {},
      DisplacementRange: {},
      VehicleWidthRange: {},
      HoodLengthRange: {},
      vehicleWeightOptions: {},
      sampleFile: {
        name: "",
        url: "",
      },
      instructionGuide: {
        url:  process.env.VUE_APP_RESOURCE_PREFIX + 'DocumentFile/DBC/Custom_DBC_Instructions.pdf',
        name: 'Custom_DBC_Instructions.pdf',
      },
      dbcFileList:[],
      oldDBCSetting:[],
      rules: {
        ModelName: [
          {
            required: true,
            message: this.$t("vehicleModel.pleaseInputModelName"), // 'Please input the fuel tank capacity',
            trigger: ["change", "blur"],
          },
          {
            max: 15,
            message: this.$t("globalText.aMaximumOf_X_CharactersCanBeUsed", {
              num: 15,
            }), // 'A maximum of 15 characters can be used',
            trigger: ["change", "blur"],
          },
        ],
        FuelType: [
          {
            required: true,
            message: this.$t("vehicleModel.pleaseInputTheFuelType"), // 'Please input the fuel tank capacity',
            trigger: ["change", "blur"],
          },
          {
            max: 20,
            message: this.$t("globalText.aMaximumOf_X_CharactersCanBeUsed", {
              num: 20,
            }), // 'A maximum of 15 characters can be used',
            trigger: ["change", "blur"],
          },
          { validator: regExp.checkFuelType, trigger: ["change", "blur"] },
        ],
        FuelTankCapacityShow: [
          {
            required: true,
            message: this.$t("tips.vehicles.pleaseInputTheFuelTankCapacity"), // 'Please input the fuel tank capacity',
            trigger: ["change", "blur"],
          },
          { validator: regExp.checkFloatOne, trigger: ["change", "blur"] },
          {
            validator: (rule, value, callback) => {
              regExp.checkRange(
                rule,
                value,
                callback,
                this.FuelTankCapacityRange.min,
                this.FuelTankCapacityRange.max
              );
            },
            trigger: ["change", "blur"],
          },
        ],
        VehicleWeight: [
          {
            required: true,
            message: this.$t("tips.vehicles.pleaseSelectVehicleWeight"), //'Please select vehicle weight',
            trigger: ["change", "blur"],
          },
        ],
        DisplacementShow: [
          {
            required: true,
            message: this.$t("tips.vehicles.pleaseInputTheEngineDisplacement"), // 'Please input the engine displacement',
            trigger: ["change", "blur"],
          },
          { validator: regExp.checkFloatOne, trigger: ["change", "blur"] },
          {
            validator: (rule, value, callback) => {
              regExp.checkRange(
                rule,
                value,
                callback,
                this.DisplacementRange.min,
                this.DisplacementRange.max
              );
            },
            trigger: ["change", "blur"],
          },
        ],

        VehicleWidthShow: [
          {
            required: true,
            message: this.$t("tips.vehicles.pleaseInputTheVehicleWidth"), // 'Please input the engine displacement',
            trigger: ["change", "blur"],
          },
          { validator: regExp.checkFloatOne, trigger: ["change", "blur"] },
          {
            validator: (rule, value, callback) => {
              regExp.checkRange(
                rule,
                value,
                callback,
                this.VehicleWidthRange.min,
                this.VehicleWidthRange.max
              );
            },
            trigger: ["change", "blur"],
          },
        ],
        HoodLengthShow: [
          {
            required: true,
            message: this.$t("tips.vehicles.pleaseInputTheHoodLength"), // 'Please input the engine displacement',
            trigger: ["change", "blur"],
          },
          { validator: regExp.checkFloatOne, trigger: ["change", "blur"] },
          {
            validator: (rule, value, callback) => {
              regExp.checkRange(
                rule,
                value,
                callback,
                this.HoodLengthRange.min,
                this.HoodLengthRange.max
              );
            },
            trigger: ["change", "blur"],
          },
        ],
        DriverSeat: [
          {
            required: true,
            message: this.$t("vehicleModel.pleaseSelectDriverSeat"), // 'Please input the engine displacement',
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  computed: {
    unitLiter() {
      return this.$unit.getLUnit(this);
    },
    unitLCC() {
      return this.$unit.getLOrCIDUnit(this);
    },
    unitCm() {
      return this.$unit.getCmUnit(this);
    },

    currentUnitType() {
      return this.$store.getters.unit;
    },
  },
  watch: {
    "vehicleModelInfo.FuelTankCapacityShow"(val) {
      this.vehicleInfoMetric.FuelTankCapacityMetric =
        this.$unit.changeLiterUnitToMetric(
          parseFloat(val),
          this.currentUnitType
        );
    },
    "vehicleModelInfo.DisplacementShow"(val) {
      this.vehicleInfoMetric.DisplacementMetric =
        this.$unit.convertDisplacementToMetric(
          parseFloat(val),
          this.currentUnitType
        );
    },

    "vehicleModelInfo.VehicleWidthShow"(val) {
      this.vehicleInfoMetric.VehicleWidthMetric =
        this.$unit.convertCmUnitToMetric(val, this.currentUnitType) / 100;
    },
    "vehicleModelInfo.HoodLengthShow"(val) {
      this.vehicleInfoMetric.HoodLengthMetric =
        this.$unit.convertCmUnitToMetric(val, this.currentUnitType) / 100;
    },
    "vehicleModelInfo.DBC.MainModel"(val) {
      if (val && val != "D705") {
          this.sampleFile.name = this.vehicleModelInfo.DBC.ConnectionType;
          this.sampleFile.url =
            process.env.VUE_APP_RESOURCE_PREFIX + 
            `SampleFiles/DBC/VIA_Mobile360_${val}_${this.vehicleModelInfo.DBC.ConnectionType.replace(/\s*/g,"")}_custom.dbc`; 
      }
    },
  },
  methods: {
    initData() {
      this.initVehicleModeData();
      this.initDeviceModelData();
      this.initFuelTankCapacityRange();
      this.initWeightOptions();
      this.initDisplacementRange();
      this.initVehicleWidthRange();
      this.initHoodLengthRange();
    },
    initDeviceModelData: function () {
      this.$serverApi.company.getDeviceModel((data) => {
        if(data){
          this.DeviceModelList = data.map(item => {
              return {
                value:item,
                fullName: this.$t("login.VIAMobile360") + " " + item
              }
          });
        }
       
      });
    },
    initVehicleModeData: async function () {
      if (this.isEdit) {
        this.title = this.$t("vehicleModel.editVehicleModel");
        this.loading = true;
        try {
          let vehicleModeData = await this.$serverApi.model.modelData(
            this.modeId
          );
          this.loading = false;
          this.vehicleInfoMetric = {
            FuelTankCapacityMetric: parseFloat(
              vehicleModeData.FuelTankCapacity
            ),
            DisplacementMetric: parseFloat(vehicleModeData.Displacement),
            VehicleWidthMetric: vehicleModeData.ADASWidth * 100,
            HoodLengthMetric: vehicleModeData.ADASHoodLength * 100,
          };
          this.vehicleModelInfo = {
            ModelName: vehicleModeData.ModelName,
            FuelType: vehicleModeData.FuelType,
            VehicleWeight: vehicleModeData.Weight,
            FuelTankCapacityShow: numRound(
              this.$unit.convertLiterUnit(
                this.vehicleInfoMetric.FuelTankCapacityMetric,
                "Metric",
                this.currentUnitType
              ),
              1
            ),
            DisplacementShow: numRound(
              this.$unit.convertDisplacementByUnit(
                this.vehicleInfoMetric.DisplacementMetric,
                "Metric",
                this.currentUnitType
              ),
              1
            ),
            VehicleWidthShow: numRound(
              this.$unit.convertCmByUnit(
                this.vehicleInfoMetric.VehicleWidthMetric,
                "Metric",
                this.currentUnitType
              ),
              1
            ),
            HoodLengthShow: numRound(
              this.$unit.convertCmByUnit(
                this.vehicleInfoMetric.HoodLengthMetric,
                "Metric",
                this.currentUnitType
              ),
              1
            ),
            DriverSeat: vehicleModeData.DriverLeftRight,
            DBC: {
              Id: vehicleModeData.DBC.Id,
              ConnectionType: vehicleModeData.DBC.ConnectionType,
              Setting:vehicleModeData.DBC.Setting,
              IsCustomFile:false,
              MainModel:"",
            },
            DBASensitivity: vehicleModeData.DBASensitivity,
         
          };
          this.vehicleModelInfo.DBC.IsCustomFile = this.getIsCustomFile(vehicleModeData.DBC.Setting,vehicleModeData.DBC.ConnectionType);
          
          this.dbcFileList = this.getDBCFileList(this.vehicleModelInfo.DBC.Setting,this.vehicleModelInfo.DBC.ConnectionType);
          this.oldDBCSetting = this.vehicleModelInfo.DBC.Setting;
        } catch (e) {
          this.loading = false;
        }
      } else {
        this.title = this.$t("vehicleModel.addVehicleModel");
        this.vehicleModelInfo = {
          ModelName: "",
          FuelType: "",
          VehicleWeight: "",
          FuelTankCapacityShow: null,
          DisplacementShow: null,
          VehicleWidthShow: null,
          HoodLengthShow: null,
          DriverSeat: 0,
          DBC: {
            ConnectionType: "J1939",
            IsCustomFile: false,
            Setting:[],
            MainModel:"",
          },
          DBASensitivity: {
            HardBraking: 1,
            HardCornering: 1,
            HardRevving: 1,
          },
         
        };
      }
    },
    getDBCFileList(dbcSetting, connectionType) {
      if (!dbcSetting || dbcSetting.length === 0 || !connectionType) return [];
      let filterSetting = dbcSetting.filter(
        (item) => item.ConnectionType === connectionType
      );
      if(filterSetting.length <= 0) return [];       
      let filterFileSetting = filterSetting[0].FileSetting.filter(
        (item) => item.Path
      );
      return filterFileSetting.map((item) => {
        return {
          MainModel: item.MainModel,
          Path: item.Path,
          IsCustomDBC: item.IsCustomDBC,
          FileName: this.getFileNameFromPath(item.Path),
        };
      });
    },
    getIsCustomFile(dbcSetting, connectionType){
      if (!dbcSetting || dbcSetting.length === 0 || !connectionType) return false;
      let filterSetting = dbcSetting.filter(
        (item) => item.ConnectionType === connectionType
      ); 
      if(filterSetting.length <= 0) return false;   
      return filterSetting[0].FileSetting.length > 0 ? filterSetting[0].FileSetting[0].IsCustomDBC : false;
    },
    initFuelTankCapacityRange() {
      if (this.$unit.isMetric()) {
        this.FuelTankCapacityRange = {
          min: 1,
          max: 2000,
        };
      } else if (this.$unit.isIMPERIAL()) {
        this.FuelTankCapacityRange = {
          min: 1,
          max: 440,
        };
      } else {
        this.FuelTankCapacityRange = {
          min: 1,
          max: 528,
        };
      }
    },
    initWeightOptions() {
      var min = numRound(this.$unit.getTNum(1.8), 1),
        max = numRound(this.$unit.getTNum(3.5), 1);
      this.vehicleWeightOptions = [
        {
          value: 10,
          label: this.$t("vehicle.under") + min + this.$t("vehicle.t"),
        },
        {
          value: 20,
          label: min + " ~ " + max + this.$t("vehicle.t"),
        },
        {
          value: 30,
          label: this.$t("vehicle.over") + max + this.$t("vehicle.t"),
        },
      ];
    },
    initDisplacementRange() {
      this.DisplacementRange = {
        min: numRound(this.$unit.convertDisplacementByUnit(0.1), 1),
        max: numRound(this.$unit.convertDisplacementByUnit(100), 1),
      };
    },
    initVehicleWidthRange() {
      this.VehicleWidthRange = {
        min: numRound(this.$unit.convertCmByUnit(100.0), 1),
        max: numRound(this.$unit.convertCmByUnit(300.0), 1),
      };
    },
    initHoodLengthRange() {
      this.HoodLengthRange = {
        min: numRound(this.$unit.convertCmByUnit(0), 1),
        max: numRound(this.$unit.convertCmByUnit(300.0), 1),
      };
    },
    handleConnectionTypeChange(val) {
      if (val !== "None") {
        this.vehicleModelInfo.DBC.IsCustomFile = false;
        this.vehicleModelInfo.DBC.MainModel = "";
        this.dbcFileList = this.getDBCFileList(this.vehicleModelInfo.DBC.Setting,this.vehicleModelInfo.DBC.ConnectionType);
      }else{
        this.dbcSetting = [];
      }
    },
    handleDBCMethodChange(){
      this.vehicleModelInfo.DBC.MainModel = "";
    },
    handleDeviceModelChange() {
      
    },
    handleUploadDone(data) {
      if(!data) return;
    
      let findIndex = this.dbcFileList.findIndex(item => { return item.MainModel === this.vehicleModelInfo.DBC.MainModel});
      if(findIndex >= 0){
        this.dbcFileList[findIndex].Path = data.Path;
        this.dbcFileList[findIndex].FToken = data.FToken;
        this.dbcFileList[findIndex].FileName = data.fileName
        ;
      }else{
        this.dbcFileList.push({
          MainModel:this.vehicleModelInfo.DBC.MainModel,
          FToken: data.FToken,
          Path:data.Path,
          FileName:data.fileName
        })
      }
    },
    handleClose() {
      this.$emit("onClose");
    },
    getNoDbcDeviceModel(){
      return this.DeviceModelList.filter(item => {
        let find = this.dbcFileList.findIndex(subItem => subItem.MainModel === item.value);
        return find < 0;
      })?.map(item => item.fullName)
    },
    async onSave() {
      try {
        await this.$refs["vehicleModelform"].validate();
        let saveVehicleModelInfo = {
          ModelName: this.vehicleModelInfo.ModelName,
          FuelTankCapacity: this.vehicleInfoMetric.FuelTankCapacityMetric,
          FuelType: this.vehicleModelInfo.FuelType,
          Weight: this.vehicleModelInfo.VehicleWeight,
          Displacement: this.vehicleInfoMetric.DisplacementMetric,
          DriverLeftRight: this.vehicleModelInfo.DriverSeat,
          ADASWidth: this.vehicleInfoMetric.VehicleWidthMetric,
          ADASHoodLength: this.vehicleInfoMetric.HoodLengthMetric,
          DBC: {
            ConnectionType: this.vehicleModelInfo.DBC.ConnectionType,
            Setting:this.oldDBCSetting.map(item => {
              item.FileSetting = item.FileSetting?.map(subItem => {
                return {
                  MainModel: subItem.MainModel,
                  IsCustomDBC: subItem.IsCustomDBC,
                }
              })
              return item;
            })
          },
          DBASensitivity: {
            HardBraking: this.vehicleModelInfo.DBASensitivity.HardBraking,
            HardCornering: this.vehicleModelInfo.DBASensitivity.HardCornering,
            HardRevving: this.vehicleModelInfo.DBASensitivity.HardRevving,
          },
        };
        if (saveVehicleModelInfo.DBC.ConnectionType !== "None") {
          let updateDbcSetting = null;
          if (this.vehicleModelInfo.DBC.IsCustomFile) {
             let noDbcDeviceName = this.getNoDbcDeviceModel();
            console.log(noDbcDeviceName);
            if(noDbcDeviceName.length > 0){
                let confirmTips = this.$tc("vehicleModel.dbcUploadTips", noDbcDeviceName.length > 1 ? 2: 1,{
                  deviceName: noDbcDeviceName.toString(),
              });
              await this.$customConfirm(confirmTips, {type: 'warning'});
            }
             updateDbcSetting = {
                ConnectionType: this.vehicleModelInfo.DBC.ConnectionType,
                FileSetting: this.dbcFileList?.map(item=> {
                  return {
                    MainModel: item.MainModel,
                    FToken:item.FToken,
                    IsCustomDBC: true,
                    FileName: item.FileName
                  }
                })
            }
          } else {
            updateDbcSetting = {
                ConnectionType: this.vehicleModelInfo.DBC.ConnectionType,
                FileSetting: this.DeviceModelList.map(item => {
                  return {
                    MainModel: item.value,
                    IsCustomDBC: false,
                  }
                })
            }
          }
          if(updateDbcSetting)
          {
            let find = saveVehicleModelInfo.DBC.Setting?.findIndex(item => item.ConnectionType === this.vehicleModelInfo.DBC.ConnectionType)
            if(find >= 0){
              saveVehicleModelInfo.DBC.Setting[find] = updateDbcSetting;
            }else{
              saveVehicleModelInfo.DBC.Setting.push(updateDbcSetting);
            }
          }  
        }
        this.isSaving = true;
        try {
          if (!this.isEdit)
            await this.$serverApi.model.addModel(saveVehicleModelInfo);
          else {
            saveVehicleModelInfo.Id = this.modeId;
            await this.$serverApi.model.editModel(saveVehicleModelInfo);
          }
          this.isSaving = false;
          this.$message({
            message: this.$t("globalText.savedSuccessfully"),
            type: "success",
          });
          this.$emit("refreshList");
          this.$emit("onClose");
        } catch (e) {
          this.isSaving = false;
          if (e.code === 814) {
            let msg = this.$t("vehicleModel.modelName_AlreadyExists", {
              modelName: this.vehicleModelInfo.ModelName.trim(),
            });
            this.$customAlert(msg);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(file){
      var x=new XMLHttpRequest();
	    x.open("GET", file.url, true);
	    x.responseType = 'blob';
	    x.onload=(e) =>{
        download(x.response, file.name, "text/plain" );
      }
	    x.send();
    },
    getFileNameFromPath(path){
      if(!path) return "";
      const pathArray = path.split("/");
      const lastIndex = pathArray.length - 1;
      return pathArray[lastIndex];
    }
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/color.styl'

.vehicle-model-content
  padding: 20px 40px

  .vmc-box
    margin-bottom: 20px
    border-bottom: solid 1px $color_gray_third

    .vmc-row
      border: solid 1px $color_gray_third
      border-bottom: none
      display: flex
      justify-content: space-between
      align-items: center

      .vmc-row-item
        border-right: solid 1px $color_gray_third
        padding: 0px 10px
        flex-basis: calc((100% / 3))
        display: flex
        align-items: center
        gap: 10px

        >>> .el-form-item
          margin: 10px 10px 12px 0
          display: flex
          align-items: center

        >>> .el-form-item__label
          word-break: break-word
          line-height: normal

        >>> .el-form-item__content
          margin-left: 0px !important

        >>> .el-form-item__error
          padding-top: 0 !important
          width: 250px

    .vmc-row-item-input
      width: 210px

    .vmc-row-item:last-child
      border-right: none

    .vmc-row:first-child
      height: 40px
      line-height: 40px
      font-size: 16px
      padding-left: 10px
      background: $color_blue_second
      color: $color_white
      border: solid 1px $color_blue_second

  .button-row
    margin-top: 40px
    margin-bottom: 20px

.vehicle-model-content
  .vmc-row-item-slide
    width: 400px

  >>> .el-slider__stop
    top: -5px
    height: 6px
    width: 2px
    border-radius: 5px
    background-color: $color_gray_third

  >>> .el-slider__marks-text
    font-size: 12px
    margin-top: 6px

  >>> .el-slider__marks-text:last-child
    width: 40px

  >>> .el-slider__button
    width: 15px
    height: 15px
    border: 2px solid $color_blue_second
    background-color: $color_blue_second

  >>> .el-slider__button:hover
    transform: scale(1.1)

.file-name-box
  border: 1px solid $color_gray_second
  border-radius: 5px
  padding: 0px 10px
  height: 26px
  line-height: 26px

  i
    margin-right: 5px
    color: $color_black
</style>
